import React from 'react';
import SEO from "../common/SEO";
import {Link} from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import HeaderTopBar from '../common/header/HeaderTopBar';
import HeaderOne from '../common/header/HeaderOne';
import FooterOne from '../common/footer/FooterOne';
import Copyright from '../common/footer/Copyright';
import ServiceTwo from '../elements/service/ServiceTwo';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import AboutTwo from "../elements/about/AboutTwo";
import CounterUpTwo from "../elements/counterup/CounterUpTwo";

import Separator from "../elements/separator/Separator";
import TeamFour from '../elements/team/TeamFour';
import PricingTwo from '../elements/pricing/PricingTwo';
import CalltoActionFive from '../elements/calltoaction/CalltoActionFive';

import Slider from "react-slick";
import { BannerActivation } from "../utils/script";
import Typed from 'react-typed';
import ServiceFive from '../elements/service/ServiceFive';
import ScrollAnimation from "react-animate-on-scroll";
import PortfolioOne from "../elements/portfolio/PortfolioOne";
import SlipFour from "../elements/split/SlipFour";


const BannerData = [
    {
        image: "/images/bg/world-map4.jpg",
        title: "UFTAA",
        description: "UFTAA (United Federation of Travel Agents Associations) is an international confederation representing the travel agency and tourism industry, founded in 1966 and headquartered in Monaco, aims to unify travel agencies, promote sustainable tourism, and advocate for the industry's interests globally. It is a huge networking opportunity for the industry stake-holders in Travel , Tourism, Hospitality, Technology, Mice and more, across the world.ions is an association of travel agents and tour operators.",
    
    },
    {
        image: "/images/bg/world-map2.jpg",
        title: "UFTAA",
        description: "UFTAA (United Federation of Travel Agents Associations) is an international confederation representing the travel agency and tourism industry, founded in 1966 and headquartered in Monaco, aims to unify travel agencies, promote sustainable tourism, and advocate for the industry's interests globally. It is a huge networking opportunity for the industry stake-holders in Travel , Tourism, Hospitality, Technology, Mice and more, across the world.ions is an association of travel agents and tour operators.",
        // description2: "Membership is open to all national travel agents, associations such as TAAI, AATTA, and EATTA."
    },
    ,
    {
        image: "/images/bg/world-map3.jpg",
        title: "UFTAA",
        description: "UFTAA (United Federation of Travel Agents Associations) is an international confederation representing the travel agency and tourism industry, founded in 1966 and headquartered in Monaco, aims to unify travel agencies, promote sustainable tourism, and advocate for the industry's interests globally. It is a huge networking opportunity for the industry stake-holders in Travel , Tourism, Hospitality, Technology, Mice and more, across the world.ions is an association of travel agents and tour operators.",
        // description2: "The main objective of the association is the promotion, development, and expansion of the travel and tourism industry worldwide."
    },
    // {
    //     image: "/images/bg/ufta3.jpg",
    //     title: "UFTAA",
    //     description: "Representing 30,000 travel agencies from 120 member countries"
    // },
]

const Corporate = () => {
    return (
        <>
            <SEO title="Corporate" />
            <main className="page-wrapper">
                
                <div className="header-transparent-with-topbar">
                    {/* <HeaderTopBar /> */}
                    <HeaderOne btnStyle="btn-small btn-icon" HeaderSTyle="header-not-transparent sticky" />
                </div>

                {/* Start Slider area  */}
                {/* <div className="slider-area slider-style-2 height-950 bg_image" data-black-overlay="3" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/_54bb4131-aa89-4fb7-a0ed-ac643d41dfe8.jpeg)`}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-start">
                                    <h4 className="subtitle"><span className="theme-gradient">DIGITAL CONSULTING AGENCY</span></h4>
                                    <h1 className="title display-one">Join Corporate Meeting.</h1>
                                    <ul className="list-icon">
                                        <li><span className="icon"><FiCheck /></span> Track your teams progress with mobile app.</li>
                                        <li><span className="icon"><FiCheck /></span> Lorem ipsum dolor sit amet consectetur adipisicing.</li>
                                        <li><span className="icon"><FiCheck /></span> Your teams progress with mobile app.</li>
                                    </ul>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Slider area  */}
               
                <Slider className="slider-area slider-style-4 slider-dot rn-slick-dot rn-slick-arrow" {...BannerActivation}>
                    {BannerData.map((data, index) => (
                        <div key={index} className="single-slide">
                            <div className="height-650 bg-overlay bg_image" data-black-overlay="5" style={{backgroundImage: `url(${process.env.PUBLIC_URL} ${data.image})`}}>
                                <div className="container">
                                    <div className="row align-items-center">
                                        <div className="col-12">
                                            <div className="inner text-left">
                                                <h1 className="title" dangerouslySetInnerHTML={{__html: data.title}}></h1>
                                                <p className="description" dangerouslySetInnerHTML={{__html: data.description}} style={{fontSize:"18px", background:"#4b5d6e", padding: "0 19px", opacity: "0.3"}}></p>
                                                <p className="description" dangerouslySetInnerHTML={{__html: data.description2}} style={{fontSize:"18px", background:"#4b5d6e", padding: "0 19px", opacity: "0.3"}}></p>
                                                {/* <p className="description" dangerouslySetInnerHTML={{__html: data.description2}}></p>
                                                <p className="description" dangerouslySetInnerHTML={{__html: data.description3}}></p> */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>

                {/* <div className="rwt-split-area">
                    <div className="wrapper">
                        <SlipFour />
                    </div>
                </div> */}

                <AboutTwo />

                {/* <div className="main-content">
                    <div className="rwt-elements-area rn-section-gap">
                        <div className="container-fluid plr--30">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Services"
                                        title = "Services We Offer"
                                        description = ""
                                    />
                                </div>
                            </div>
                            <PortfolioOne Column="col-lg-4 col-md-6 mt--30 box-grid-layout no-overlay" />
                        </div>
                    </div>
                </div> */}

            {/* Start Elements Area  */}
       


                {/* End Elements Area  */}

                {/* Start Service Area  */}
                {/* <div className="rn-service-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "What we can do for you"
                                    title = "Services provide for you."
                                    description = "There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration."
                                    />
                            </div>
                        </div>
                        <ServiceTwo 
                            cardStyle = "card-style-1"
                            textAlign = "text-start"
                            />
                    </div>
                </div> */}
                {/* End Service Area  */}
{/* 
                <Separator />

                <AboutTwo />

                <Separator />
                
                <Separator /> */}
                {/* Start Elements Area  */}
                {/* <div className="rwt-team-area rn-section-gap">
                    <div className="wrapper plr--65 plr_md--15 plr_sm--15">
                        <div className="row mb--20">
                            <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Our Experts."
                                        title = "Our Experts Team"
                                        description = ""
                                    />
                            </div>
                        </div>
                        <TeamFour column="col-lg-6 col-xl-3 col-md-6 col-12 mt--30" teamStyle="team-style-three" />
                    </div>
                </div> */}
                {/* End Elements Area  */}

                <Separator />
                {/* Start Elements Area  */}
                {/* <div className="rwt-pricing-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--35">
                            <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Pricing"
                                        title = "Our Pricing Plan."
                                        description = ""
                                    />
                            </div>
                        </div>
                        <PricingTwo />
                    </div>
                </div> */}
                {/* End Elements Area  */}

                {/* Start Call To Action Area  */}
                {/* <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <CalltoActionFive />
                    </div>
                </div> */}
                {/* End Call To Action Area  */}

                <FooterOne />
                <Copyright />
            </main>
        </>
    )
}

export default Corporate
